// Clean GTM implementation without any blocking code
declare global {
  interface Window {
    dataLayer: any[];
  }
}

let trackingInitialized = false;

export const initGTM = () => {
  if (trackingInitialized) {
    console.log('GTM already initialized');
    return;
  }

  try {
    window.dataLayer = window.dataLayer || [];
    
    window.dataLayer.push({
      event: 'app_ready',
      timestamp: new Date().getTime()
    });

    trackingInitialized = true;
    console.log('GTM ready for tracking');

  } catch (error) {
    console.error('Error initializing GTM:', error);
  }
};